import React, { useState, useEffect, Suspense } from 'react';
import { ContainerLayoutType } from '../../../../../model';
import { useAppSelector } from '../../../../../redux';
import { ReCaptchaEulaChooseSignup } from '../../sign-up-form/components/styled';
import { WacSignupHeader } from '../../signup-header';
import { SideInfoFirstImpressions } from '../component';
import {
  ChooseSignupRightContainer,
  FirstImpressionsForm,
  LeftContainer,
  PageBody,
  PageRoot,
  RightContainer
} from '../component/first-impressions';
import { messages } from '../../../../../messages/sign-up-form';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
//@ts-ignore
const EasterEgg = React.lazy(() => import('../component/easter-egg'));

export function LayoutFirstImpressions(props: ContainerLayoutType) {
  const { deferredSiteName } = useAppSelector((store) => store);

  const [hidden, setHidden] = useState(true);

  const isConfluence =
    (props.productKeys ?? []).filter((item) =>
      item.product.includes('confluence')
    ).length > 0;

  useEffect(() => {
    // @ts-ignore
    window.sugar = () => {
      setHidden(false);
      setTimeout(() => {
        setHidden(true);
      }, 5000);
    };
  }, []);

  return (
    <PageRoot firstImpressionsImageUrls={props.firstImpressionsImageUrls}>
      <WacSignupHeader
        productKeys={props.productKeys}
        isWhiteBackground={false}
      />
      <PageBody>
        <Suspense fallback={null}>{!hidden ? <EasterEgg /> : null}</Suspense>
        <LeftContainer>
          <SideInfoFirstImpressions
            {...props}
            isDeferredSiteNameEnabled={deferredSiteName.isEnabled}
          />
        </LeftContainer>
        {isConfluence ? (
          <ChooseSignupRightContainer>
            <FirstImpressionsForm
              {...props}
              isDeferredSiteNameEnabled={deferredSiteName.isEnabled}
            />
          </ChooseSignupRightContainer>
        ) : (
          <RightContainer>
            <FirstImpressionsForm
              {...props}
              isDeferredSiteNameEnabled={deferredSiteName.isEnabled}
            />
          </RightContainer>
        )}
      </PageBody>
      {isConfluence && (
        <ReCaptchaEulaChooseSignup>
          <SanitizedFormattedHtmlMessage {...messages.reCaptchaLegal} />
        </ReCaptchaEulaChooseSignup>
      )}
    </PageRoot>
  );
}
